var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appointment"},[_c('pdfs',{staticClass:"m-b-20 pdfs"}),_c('div',{staticClass:"handwriting",on:{"click":function($event){return _vm.viewPage()}}},[_vm._v("确认签名")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }